// @flow
import { IMMERSIVE, PRODUCT_IMMERSIVE } from 'Client/cms/toolkit/constants';

const IMMERSIVE_COMPONENTS = [IMMERSIVE, PRODUCT_IMMERSIVE];

function isImmersive(lineName: string): boolean {
  return IMMERSIVE_COMPONENTS.includes(lineName);
}

export { isImmersive };
